module.exports = __webpack_public_path__ + "static/media/mercado-pago.ab3a4198.jpeg";